export function testimonialsSlider() {
    $('.testimonials-slider-holder').each(function () {
        const slider = $(this).find('.testimonials-slider');
        const sliderNav = $(this).find('.testimonials-controls');
        slider.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            dots: true,
            fade: true,
            appendArrows: sliderNav,
            appendDots: sliderNav
        })
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialsSlider.js